import { StatusType, Monitoring } from '../../../types'

export const mapComplianceStatus = (
  monitoring: Monitoring
): StatusType.Approved | StatusType.Rejected | StatusType.Pending | StatusType.Cancelled => {
  if (
    (monitoring?.status === 'live' || monitoring?.status === 'cancelled') &&
    monitoring?.results?.complianceStatus === 'pass'
  ) {
    return StatusType.Approved
  }

  if (monitoring?.results?.complianceStatus === 'fail' || monitoring?.status === 'validation_request_failed') {
    return StatusType.Rejected
  }

  if (monitoring?.status === 'cancelled') {
    return StatusType.Cancelled
  }

  return StatusType.Pending
}
